import { jsxs, jsx } from 'react/jsx-runtime';
import { useFooterAnimationContext } from '../../context/FooterAnimationContext/index.js';
import { useViewContext } from '../../context/ViewContext/ViewContext.js';
import { getDynamicLayoutData } from '../../utils/functions/getDynamicLayoutData/getDynamicLayoutData.js';
import 'react';
import '@dynamic-labs/sdk-api';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/wallet-connector-core';
import '@dynamic-labs/wallet-book';
import '@dynamic-labs/utils';
import '../../utils/constants/colors.js';
import '../../shared/utils/classes/storage/localStorage.js';
import 'viem';
import '../../shared/consts/index.js';
import '../../context/DynamicContext/DynamicContext.js';
import '@dynamic-labs/multi-wallet';
import '../../components/ShadowDOM/ShadowDOM.js';
import '../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../config/ApiEndpoint.js';
import '@dynamic-labs/rpc-providers';
import '../../utils/hooks/useWallets/utils/verifyMagicIsSetup/verifyMagicIsSetup.js';
import '../../context/ErrorContext/ErrorContext.js';
import '../../context/AccessDeniedContext/AccessDeniedContext.js';
import '../../context/AccountExistsContext/AccountExistsContext.js';
import '../../components/IconButton/IconButton.js';
import '../../components/Alert/Alert.js';
import '../../context/MockContext/MockContext.js';
import '../../context/CaptchaContext/CaptchaContext.js';
import '../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { VerticalAccordion } from '../../components/Accordion/components/VerticalAccordion/VerticalAccordion.js';
import { AccordionItem } from '../../components/Accordion/components/AccordionItem/AccordionItem.js';
import '../../components/Popper/Popper/Popper.js';
import '../../components/Popper/PopperContext/PopperContext.js';
import 'formik';
import 'yup';
import { Modal } from '../../components/Modal/Modal.js';
import { ModalCard } from '../../components/ModalCard/ModalCard.js';
import '../../components/InlineWidget/InlineWidget.js';
import '../../components/MenuList/Dropdown/Dropdown.js';
import '../../components/OverlayCard/OverlayCard.context.js';
import { OverlayCardTarget } from '../../components/OverlayCard/OverlayCardTarget.js';
import { useAuthLayoutChecks } from '../../utils/hooks/useAuthLayoutChecks/useAuthLayoutChecks.js';
import { Header } from './Header/header.js';
import { ToSFooter } from './ToSFooter/ToSFooter.js';
import '../../context/WalletGroupContext/WalletGroupContext.js';
import { HelpContent } from './HelpContent/HelpContent.js';
import { WalletProgressStepper } from './WalletProgressStepper/WalletProgressStepper.js';

const DynamicAuthLayout = ({ children, onClose, transitionProps, projectSettings, walletConnector, }) => {
    const { view } = useViewContext();
    const { headerData, helpHeaderData } = getDynamicLayoutData({
        view,
    });
    const { isFooterExpanded } = useFooterAnimationContext();
    const { showHeader, showHelpContent, showToSFooter, showConnectedWalletProgress, } = useAuthLayoutChecks(walletConnector);
    return (jsxs(Modal, { isShown: Boolean(transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.isShown), children: [showConnectedWalletProgress && (jsx(ModalCard, { borderRadius: 'small', children: jsx(WalletProgressStepper, {}) })), jsx(ModalCard, { dataTestId: 'dynamic-auth-modal', children: jsx(OverlayCardTarget, { children: jsxs(VerticalAccordion, { children: [jsxs(AccordionItem, { isOpen: !isFooterExpanded, dimOnHide: true, children: [showHeader && (jsx(Header, { onClose: onClose, heading: (headerData === null || headerData === void 0 ? void 0 : headerData.heading) || '', projectSettings: projectSettings, walletConnector: walletConnector })), children, showToSFooter && jsx(ToSFooter, {})] }), helpHeaderData && showHelpContent && (jsx(AccordionItem, { isOpen: isFooterExpanded, children: jsx("div", { children: jsx(HelpContent, {}) }, isFooterExpanded.toString()) }))] }) }) })] }));
};

export { DynamicAuthLayout };
